var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.selectableYears,"label":_vm.label,"error-messages":_vm.errorMessages,"solo":""},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})
}
var staticRenderFns = []

export { render, staticRenderFns }